import script from "./SaleOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./SaleOrders.vue?vue&type=script&setup=true&lang=js"

import "./SaleOrders.vue?vue&type=style&index=0&id=d9cdd326&lang=css"

const __exports__ = script;

export default __exports__